import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React from "react";

const SeaSwimming = () => {
  const sections = [
    {
      title: "السباحة في البحر: حلم مستحيل أصبح حقيقة",
      content: `
        كانت السباحة في البحر بالنسبة لي حلماً مستحيلاً، فقد كانت هناك عوامل متعددة تمنعني من خوض هذه التجربة المميزة. 
        كان لدي تخوفات كبيرة من قناديل البحر، الأسماك، التيارات، ارتفاع الموج، وعدم القدرة على رؤية القاع. 
        الفكرة أنني لا أسيطر على الحدود الموجودة من حولي، والخوف في الأساس كان من عدم إدراكي ومعرفتي بكيفية التعامل مع البحر وكيفية التنقل فيه.
      `,
      image: "/images/ocean-swimming/fear.jpg",
    },
    {
      title: "بداية تجربة السباحة في البحر",
      content: `
        على الرغم من محاولات الفريق المتكررة لإقناعي بخوض تجربة السباحة في البحر، إلا أن تلك المحاولات كانت تفشل في كل مرة. 
        في عام 2019، رافقت السباحين في واحدة من المباريات في المياه المفتوحة. 
        شعرت في تلك اللحظة أنني لن أتنازل عن هذه التجربة، وأنه يجب علي خوضها كتحدٍّ للذات في المقام الأول. 
        إصرار وثقة السباحين بي أعطتني القوة لأخوض التجربة أخيراً.
      `,
      image: "/images/ocean-swimming/start.jpg",
    },
    {
      title: "رحلتي مع فريق السباحين في حيفا",
      content: `
        انضممت إلى مجموعة من السباحين الهواة للسباحة في المياه المفتوحة في مدينة حيفا، واستقبلوني بأفضل استقبال. 
        شرحت لهم مخاوفي، وكانوا مرافِقين لي في كل خطوة. 
        بدأت السباحة معهم مرة واحدة في الأسبوع، انطلقت في شهر سبتمبر واستمررت حتى الصيف قبل قدوم قناديل البحر.
      `,
      image: "/images/ocean-swimming/team.jpg",
    },
    {
      title: "توقف مؤقت وعودة أقوى",
      content: `
        بعد ولادة ابني باسل، اضطررت للتوقف بسبب عدم قدرتي على التوفيق بين رعاية طفلين ومواعيد السباحة المبكرة. 
        لكن كنت أعلم أنني سأعود. 
        وبعد ثلاث سنوات من الفراق، قررت العودة إلى السباحة في المياه المفتوحة، وبدأت بأخذ سباحاتي إلى شاطئ عكا للتآلف مع البحر وتضاريسه.
      `,
      image: "/images/ocean-swimming/comeback.jpg",
    },
    {
      title: "أول مباراة بحرية نسائية في البلاد",
      content: `
        شيئاً فشيئاً، ومع اكتسابي بعض الخبرة، قررت المشاركة في أول مباراة بحرية نسائية في تاريخ الدولة كفريق نسائي. 
        كانت تجربة فريدة من نوعها، مليئة بالمشاعر والإحساس بالفخر بوجود نساء عربيات في مجال المياه المفتوحة.
      `,
      image: "/images/ocean-swimming/womens-competition.jpg",
    },
    {
      title: "الخطة القادمة لتجنيد النساء للسباحة في البحر",
      content: `
        وبعد انقضاء الشتاء البارد، سأبدأ بتجنيد فرق نسائية للسباحة والتدرب في البحر. 
        لأن هذا العالم الجميل يتطلب خبرة كبيرة وتجربة وفهماً لما يدور من حولنا من مناخ، وتيارات، 
        وتحديد الأماكن الآمنة. من المهم أن تتم هذه العملية تدريجياً لضمان راحة النساء خلال تعلمهم هذا العالم.
      `,
      image: "/images/ocean-swimming/recruitment.jpg",
    },
    {
      title: "تأسيس أول فريق نسائي للسباحة في المياه المفتوحة",
      content: `
        من المؤكد أن الخطة القادمة هي بناء خطة مهنية وعملية لتأسيس أول فريق نسائي في البلاد وحول العالم للسباحة في المياه المفتوحة.
      `,
      image: "/images/ocean-swimming/future-plans.jpg",
    },
  ];

  return (
    <>
      <div className="font-sans">
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            {/* Content Section */}
            <section
              className={`py-16 px-8 bg-opacity-20 text-center ${
                index % 2 === 0 ? "bg-blueGray-200" : "bg-gray-100"
              }`}
            >
              <h2 className="text-4xl font-semibold mb-4">{section.title}</h2>
              <p className="text-lg leading-8 whitespace-pre-line">{section.content}</p>
            </section>

            {/* Parallax Image */}
            <div
              className="h-[50vh] bg-fixed bg-center bg-cover"
              style={{ backgroundImage: `url(${section.image})` }}
            ></div>
          </React.Fragment>
        ))}

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default SeaSwimming;
